import React from 'react';
import BrandBackdrop from './BrandBackdrop';
import ThreeCanvas from './three/ThreeCanvas';
import ThreeNudgytAgentClient from './three/ThreeNudgytAgentClient';
import ThreeNudgytAgentCoreClient from './three/ThreeNudgytAgentCoreClient';
import ThreeNudgytAgentMultiCharacterClient from './multi-character/ThreeNudgytAgentMultiCharacterClient';
import AnamVideoStream from './anam/AnamVideoStream';
import useChatMessageListener from '../hooks/useChatMessageListener';
import useInitMessageListener from '../hooks/useInitMessageListener';
import useAvatarVisibilityListener from '../hooks/useAvatarVisibilityListener';
import useAudioPlaybackReporter from '../hooks/useAudioPlaybackReporter';
import { RENDERER } from '../constants/simulationConstants';
import {
  isNudgytAgentCoreSession,
  isNudgytAgentSimulationType
} from '../helpers/utils';
import { useSimulationContext } from '../providers/SimulationProvider';
import IosAudioUnlockOverlay from './IosAudioUnlockOverlay';

function SimulationContainer() {
  const { renderer, simulationType, characterEngineType, isMultiCharacter } =
    useSimulationContext();

  useInitMessageListener();
  useChatMessageListener();
  useAvatarVisibilityListener();
  useAudioPlaybackReporter();

  const renderThreeJsClient = () => {
    // Ahead of the Core check: a multi-character simulation is Core too.
    if (isMultiCharacter) return <ThreeNudgytAgentMultiCharacterClient />;

    if (isNudgytAgentCoreSession({ characterEngineType }))
      return <ThreeNudgytAgentCoreClient />;

    if (isNudgytAgentSimulationType(simulationType))
      return <ThreeNudgytAgentClient />;

    return <ThreeCanvas />;
  };

  return (
    <div className='relative w-full h-full'>
      <BrandBackdrop />

      {renderer === RENDERER.ANAM ? <AnamVideoStream /> : renderThreeJsClient()}

      <IosAudioUnlockOverlay />
    </div>
  );
}

export default SimulationContainer;
